export const SocketEventNames = {
    JOIN: 'join',
    LEAVE: 'leave',
    GRADE_APP_REJECT: 'grade_app_reject',
    GRADE_APP_ACCEPT: 'grade_app_accept',
    GRADE_APP_ONPROCESS: 'grade_app_onprocess',
    STAKEHOLDER_ACCEPTED: 'stakeholder_accepted',
    STAKEHOLDER_REJECTED: 'stakeholder_rejected',
    CLASSIFICATION_ACCEPTED: "classification_accepted",
    CLASSIFICATION_REJECTED: "classification_rejected",
    GRADE_APP_AND_CLASSIFICATION_UPDATED: "grade_app_and_classification_updated"
}